export default __webpack_public_path__ + "static/media/grandma.b6d3bec7.ogg";